const { buildErrResponse } = require("../_utils/utils");
const { BASE_URL, BASE_URL_DEV } = require("../_constants/urlConstants");
const { default: Axios } = require("axios");

export const ColorService = {
  getAllColors,
  postColor,
  deleteColor,
};

function getAllColors() {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/color`)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function postColor(body) {
  return new Promise((resolve, reject) => {
    Axios.post(`${BASE_URL_DEV}/color`, body)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function deleteColor(id) {
  return new Promise((resolve, reject) => {
    Axios.delete(`${BASE_URL_DEV}/color?id${id}`)
      .then((resp) => resolve(resp))
      .catch((err) => reject(buildErrResponse(err)));
  });
}
